const API_URL = process.env.NEXT_PUBLIC_API_URL || "https://api.aiarva.com";

async function apiFetch<T>(
  path: string,
  options: { method?: string; token?: string; body?: string } = {},
): Promise<T> {
  const { method = "GET", token, body } = options;
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };
  if (token) headers["Authorization"] = `Bearer ${token}`;

  const res = await fetch(`${API_URL}${path}`, { method, headers, body });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail || `Request failed (${res.status})`);
  }
  return res.json();
}

export const api = {
  auth: {
    login: (email: string, password: string) =>
      apiFetch<any>("/auth/login", {
        method: "POST",
        body: JSON.stringify({ email, password }),
      }),
    register: (name: string, email: string, password: string) =>
      apiFetch<any>("/auth/register", {
        method: "POST",
        body: JSON.stringify({ name, email, password }),
      }),
    me: (token: string) => apiFetch<any>("/auth/me", { token }),
    googleCallback: async (code: string) => {
      const redirect_uri = `${window.location.origin}/auth/google/callback`;
      const res = await apiFetch<any>("/auth/google/callback", {
        method: "POST",
        body: JSON.stringify({ code, redirect_uri }),
      });
      if ("mfa_required" in res) return res;
      const user = await apiFetch<any>("/auth/me", { token: res.access_token });
      return { ...res, user };
    },
  },

  apiKeys: {
    list: (token: string) => apiFetch<any>("/api-keys", { token }),
    create: (
      token: string,
      data: { name: string; expires_in_days?: number; rate_limit?: number },
    ) =>
      apiFetch<any>("/api-keys", {
        method: "POST",
        token,
        body: JSON.stringify(data),
      }),
    revoke: (token: string, id: string) =>
      apiFetch<any>(`/api-keys/${id}`, { method: "DELETE", token }),
    rotate: (token: string, id: string) =>
      apiFetch<any>(`/api-keys/${id}/rotate`, { method: "POST", token }),
  },
};
